import React from "react";
import { Card, CardContent, Button, Stack, Typography } from "@mui/material";
import BuildIDLogo from "../../assets/images/build_id_logo.png";
import { BIBlue, BIYellow } from "../../assets/helpers";

export const SignInCard = () => {
  const handleSignInClick = () => {};
  const handleSignUpClick = () => {};

  return (
    <Card>
      <CardContent>
        <Stack spacing={2} alignItems="center" justifyContent="center" padding="25px 0px">
          <img src={BuildIDLogo} alt="Logo" style={{ width: "100px", height: "auto" }} />

          <Typography variant="body1" align="center">
            You must be a BuildID member to view this content.
          </Typography>

          <Button
            variant="contained"
            sx={{
              width: "16rem",
              fontWeight: "bold",
              background: BIYellow,
              color: BIBlue
            }}
            onClick={handleSignInClick}>
            SIGN IN
          </Button>

          <Typography variant="body2" align="center">
            <b>
              Don't have an account?{" "}
              <Typography
                component="span"
                sx={{
                  color: BIBlue,
                  textDecoration: "underline",
                  cursor: "pointer"
                }}
                onClick={handleSignUpClick}>
                Sign up for free
              </Typography>
            </b>
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
